/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Browser_Extensions_Scope_Output5Inputs */

const en_svc_browser_extensions_scope_output5 = /** @type {(inputs: Svc_Browser_Extensions_Scope_Output5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Extension spec`)
};

const ar_svc_browser_extensions_scope_output5 = /** @type {(inputs: Svc_Browser_Extensions_Scope_Output5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مواصفات الإضافة`)
};

const bn_svc_browser_extensions_scope_output5 = /** @type {(inputs: Svc_Browser_Extensions_Scope_Output5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`এক্সটেনশন স্পেক`)
};

const de_svc_browser_extensions_scope_output5 = /** @type {(inputs: Svc_Browser_Extensions_Scope_Output5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erweiterungsspezifikation`)
};

const es_svc_browser_extensions_scope_output5 = /** @type {(inputs: Svc_Browser_Extensions_Scope_Output5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Especificación de extensión`)
};

const fr_svc_browser_extensions_scope_output5 = /** @type {(inputs: Svc_Browser_Extensions_Scope_Output5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spécification d'extension`)
};

const pt_svc_browser_extensions_scope_output5 = /** @type {(inputs: Svc_Browser_Extensions_Scope_Output5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Especificação da extensão`)
};

const zh_svc_browser_extensions_scope_output5 = /** @type {(inputs: Svc_Browser_Extensions_Scope_Output5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`扩展规范`)
};

const tr_svc_browser_extensions_scope_output5 = /** @type {(inputs: Svc_Browser_Extensions_Scope_Output5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uzantı spesifikasyonu`)
};

const ru_svc_browser_extensions_scope_output5 = /** @type {(inputs: Svc_Browser_Extensions_Scope_Output5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Спецификация расширения`)
};

const pl_svc_browser_extensions_scope_output5 = /** @type {(inputs: Svc_Browser_Extensions_Scope_Output5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Specyfikacja rozszerzenia`)
};

/**
* | output |
* | --- |
* | "Extension spec" |
*
* @param {Svc_Browser_Extensions_Scope_Output5Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_browser_extensions_scope_output5 = /** @type {((inputs?: Svc_Browser_Extensions_Scope_Output5Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Browser_Extensions_Scope_Output5Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_browser_extensions_scope_output5(inputs)
	if (locale === "bn") return bn_svc_browser_extensions_scope_output5(inputs)
	if (locale === "de") return de_svc_browser_extensions_scope_output5(inputs)
	if (locale === "es") return es_svc_browser_extensions_scope_output5(inputs)
	if (locale === "fr") return fr_svc_browser_extensions_scope_output5(inputs)
	if (locale === "pt") return pt_svc_browser_extensions_scope_output5(inputs)
	if (locale === "zh") return zh_svc_browser_extensions_scope_output5(inputs)
	if (locale === "tr") return tr_svc_browser_extensions_scope_output5(inputs)
	if (locale === "ru") return ru_svc_browser_extensions_scope_output5(inputs)
	if (locale === "pl") return pl_svc_browser_extensions_scope_output5(inputs)
	return en_svc_browser_extensions_scope_output5(inputs)
});
export { svc_browser_extensions_scope_output5 as "svc_browser-extensions_SCOPE_output" }